import React from 'react';
import Styles from './MaoNaRoda25Comparativo.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';

function MaoNaRoda25Comparativo() {
  return (
    <>
      <section id="mao-na-roda-comparativo">
        <ContainerHome24>
          <h2 className="comparativo-titulo">Escolha a melhor opção para você e seu veículo</h2>

          <div className="comparativo-tabela">
            <div className="comparativo-tag">
              <img src="assets/mao-na-roda-25/ic-santander-symbol.svg" alt="" />
              Mão na Roda
            </div>

            <div className="tabela-header">
              <div className="tabela-col">
                <img src="assets/mao-na-roda-25/ic-carro.svg" alt="" />
                Carro
              </div>
              <div className="tabela-col">
                <img src="assets/mao-na-roda-25/ic-moto.svg" alt="" />
                Moto
              </div>
            </div>

            <div className="tabela-titulo">
              <div className="tabela-titulo-col">
                <strong>Pequenos reparos - Serviço</strong>
                <span>
                  Peças de plástico externas e/ou da lataria do veículo danificadas em colisões
                </span>
              </div>
              <div className="tabela-titulo-col">
                <strong>Pequenos reparos - Serviço</strong>
                <span>
                  Cobertura para reparo e pintura da lataria (tanque e carenagem da moto), cobrindo
                  a mão de obra de reparo e instalações necessárias
                </span>
              </div>
            </div>
            <div className="tabela-uso">
              <div className="tabela-uso-col">
                1 utilização/ vigência, com limite de até R$1.000 de mão-de-obra para reparação.
                Franquia de R$150.
              </div>
              <div className="tabela-uso-col">
                1 utilização/ vigência, com limite de até R$600. Franquia de R$150.
              </div>
            </div>

            <div className="tabela-titulo">
              <div className="tabela-titulo-col">
                <strong>Pequenos reparos - Reembolso</strong>
                <span>
                  Ressarcimento ao segurado dos valores de itens danificados (vidros, fechadura e
                  miolo de ignição) no caso de tentativa de roubo/furto
                </span>
              </div>
              <div className="tabela-titulo-col">
                <strong>Pequenos reparos - Reembolso</strong>
                <span>
                  Ressarcimento ao segurado dos valores de itens danificados (retrovisores, fiação,
                  miolo de ignição) no caso de tentativa de roubo/furto
                </span>
              </div>
            </div>
            <div className="tabela-uso">
              <div className="tabela-uso-col">
                1 utilização/ vigência com limite de R$1.000. Franquia de 10% sobre o valor
                solicitado.
              </div>
              <div className="tabela-uso-col">
                1 utilização/ vigência com limite de R$1.000. Franquia de 10% sobre o valor
                solicitado.
              </div>
            </div>

            <div className="tabela-titulo tabela-titulo-full">
              <strong>Pneus, rodas e suspensão</strong>
              <span>
                Cobertura para proteção de rodas, pneus e suspensão contra danos causados por
                impactos acidentais em guias, blocos de sinalização, buracos, etc.
              </span>
            </div>
            <div className="tabela-uso">
              <div className="tabela-uso-col">
                1 utilização/ vigência, com limite de 1 peça por acionamento. Franquia de R$180.
              </div>
              <div className="tabela-uso-col">
                1 utilização por vigência, com limite de 1 peça por acionamento. Franquia: R$
                120,00.
              </div>
            </div>
          </div>
        </ContainerHome24>
      </section>

      <style jsx>{Styles}</style>
    </>
  );
}

export default MaoNaRoda25Comparativo;
